import { inlinePopupSelectTheme } from "..";

export const withColoredBackground = (theme: inlinePopupSelectTheme) =>
    ![inlinePopupSelectTheme.inline, inlinePopupSelectTheme.noBorder, inlinePopupSelectTheme.table_editor].includes(
        theme
    );

export const isInline = (theme: inlinePopupSelectTheme) => theme === inlinePopupSelectTheme.inline;
